import { Component, ElementRef, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AuthService } from 'src/app/auth/services/auth.service';
import { BlogsComponent } from 'src/app/shared/components/blogs/blogs.component';
import { NewsComponent } from 'src/app/shared/components/news/news.component';
import { DayIDEnum, IBaseBlogsRequest, IBaseNewsRequest, IBlogs, IBlogsDeleteAllRequest, IBlogsUpdateRequest, ICategoryDaysAssign, IDaysAssign, INews, INewsDeleteAllRequest, INewsUpdateRequest, ISingleBlog, ISingleNews, NewsBlogsService } from 'src/app/shared/services/news-blogs.service';
import { SettingService } from 'src/app/shared/services/setting.service';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { NotificationBellServiceService } from 'src/app/store/services/notification-bell-service.service';
import { INotifications, NotificationServiceService } from 'src/app/store/services/notification-service.service';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { IconService } from 'src/app/shared/services/icon.service';
import { ITranslatableText } from 'src/app/store/services/store.service';
import { AccountService, IApiAccount } from 'src/app/account/services/account.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-announcements',
  templateUrl: './announcements.component.html',
  styleUrls: ['./announcements.component.scss'],
  standalone: false
})
export class AnnouncementsComponent  implements OnInit {
  title: string = 'Nav.Announcements';

  newsRequest: IBaseNewsRequest;
  blogsRequest: IBaseBlogsRequest;
  updateNewsRequest: INewsUpdateRequest;
  updateBlogsRequest: IBlogsUpdateRequest;
  deleteAllNewsRequest: INewsDeleteAllRequest;
  deleteAllBlogsRequest: IBlogsDeleteAllRequest;

  //news: any[] = [];
  //blogs: any[] = [];


  blogsCategories: IBlogs[] = [];
  newsCategories: INews[] = [];

  SelectedDayCategory: ICategoryDaysAssign[] = [];
  daysByCategory: IDaysAssign[] = [
    { 
      value: DayIDEnum.Monday, 
      viewValue: {
        translations: {
          en: "Monday",
          fr: "Lundi"
        }
      },
      selected: false 
    },
    {
      value: DayIDEnum.Tuesday, 
      viewValue: {
        translations: {
          en: "Tuesday",
          fr: "Mardi"
        }
      },
      selected: false 
    },
    { 
      value: DayIDEnum.Wednesday, 
      viewValue: {
        translations: {
          en: "Wednesday",
          fr: "Mercredi"
        }
      },
      selected: false  
    },
    { 
      value: DayIDEnum.Thursday, 
      viewValue: {
        translations: {
          en: "Thursday",
          fr: "Jeudi"
        }
      },
      selected: false  
    },
    { 
      value: DayIDEnum.Friday, 
      viewValue: {
        translations: {
          en: "Friday",
          fr: "Vendredi"
        }
      },
      selected: false  
    },
    { 
      value: DayIDEnum.Saturday, 
      viewValue: {
        translations: {
          en: "Saturday",
          fr: "Samedi"
        }
      },
      selected: false  
    },
    { 
      value: DayIDEnum.Sunday, 
      viewValue: {
        translations: {
          en: "Sunday",
          fr: "Dimanche"
        }
      },
      selected: false  
    }
  ];

  //{{ newsblog.shortDescription.translations[translationService.getLanguage()] }}
  valideNotification: number;
  AllNotifications: INotifications[];

  bellIcon: IconDefinition;

  activeBlogByCategory: Record<string, string> = {};
  activeNewsByCategory: Record<string, string> = {};

  isActiveBlog(blog: ISingleBlog, category: IBlogs): boolean {
    return this.activeBlogByCategory[category.id] === blog.id;
  }
  setActiveBlog(blog: ISingleBlog, category: IBlogs): void {
    this.activeBlogByCategory[category.id] = blog.id;
  }

  isActiveNews(news: any, category: INews): boolean {
    return this.activeNewsByCategory[category.id] === news.id;
  }

  setActiveNews(news: any, category: INews): void {
    this.activeNewsByCategory[category.id] = news.id;
  }
  
  primary: IApiAccount;

  constructor(
    private modalCtrl: ModalController,
    public settingService: SettingService,
    private newsBlogService: NewsBlogsService,
    public translationService: TranslationService,
    public authservice: AuthService,
    public NotificationService: NotificationServiceService,
    public NotificationBellService: NotificationBellServiceService,
    private iconService: IconService,
    private router: Router,
    private element: ElementRef,
    private accountService: AccountService,

  ) { 
    this.bellIcon = this.iconService.getIcon('bell')!;
    this.getPrimary();
  }

  async ngOnInit() {

    const hostElement = this.element.nativeElement;
    const host = hostElement;
    host.style.setProperty('--points-container-Text-color', this.settingService.configuration?.welcomeOptions?.giftCardInfoContainerTextColor);

    this.getAllNews();
    this.getAllBlogs();

    try {
      this.valideNotification = await this.NotificationService.notificationCount();
      this.AllNotifications = this.NotificationService.notifationArray;
    } catch (e) {
      console.log("error collecting Notification Data");
    }

    // temporarily. we'll need to set it up on the page soon
    (window as any).updateLoaderProgress(100);
    (window as any).finishAppShell?.();
  }

  async getPrimary() {

    this.accountService.getPrimary()
      .subscribe(
        (primary) => {
          this.primary = primary;
          console.log(this.primary);
        });
  }

  getAllNews(){
    this.fetchNews().subscribe(async newsCat => {
      this.newsCategories = newsCat;

      for(var i = 0; i < this.newsCategories.length; i++) {
        var category = this.newsCategories[i];
        if (category.weeklyFormat) {

          // Remove any existing entry for this category
          if(this.SelectedDayCategory.length > 0) {
            this.SelectedDayCategory = this.SelectedDayCategory.filter(
              x => x.categoryId !== category.id
            );
          }
          

          this.SelectedDayCategory.push({
            categoryId: category.id,
            //days: this.getDaysStartingToday()
            days: this.getDaysStartingToday(category)
          });
        }

        for(var y = 0; y < category.news.length; y++) {
          var news = category.news[y];

          news.images['imgURL'] = await this.newsBlogService.fetchImage(news.images.imgShortName);
          news.images['imgMobileURL'] = await this.newsBlogService.fetchImage(news.images.imgMobileShortName);
        }

        

        this.initializeCategoryActiveNews(category);
      }
    });
  }

  fetchNews() {
    if(this.authservice.isAuthenticated) {
      this.newsRequest = {
        merchantId: this.settingService.getMerchantId(),
        userId: this.authservice.memberId.toString()
      }
    } else {
      this.newsRequest = {
        merchantId: this.settingService.getMerchantId(),
        userId: ""
      }
    }

    return this.newsBlogService.getNews(this.newsRequest);
  }

  getAllBlogs(){
    this.fetchBlogs().subscribe(async blogs => {
      this.blogsCategories = blogs;



      for(var i = 0; i < this.blogsCategories.length; i++) {
        var category = this.blogsCategories[i];
        if (category.weeklyFormat) {

          // Remove any existing entry for this category
          if(this.SelectedDayCategory.length > 0) {
            this.SelectedDayCategory = this.SelectedDayCategory.filter(
              x => x.categoryId !== category.id
            );
          }

          this.SelectedDayCategory.push({
            categoryId: category.id,
            //days: this.getDaysStartingToday()
            days: this.getDaysStartingToday(category)
          });
        }

        for(var y = 0; y < category.blogs.length; y++) {
          var blog = category.blogs[y];

          blog.images['imgURL'] = await this.newsBlogService.fetchImage(blog.images.imgShortName);
          blog.images['imgMobileURL'] = await this.newsBlogService.fetchImage(blog.images.imgMobileShortName);
        }

        

        this.initializeCategoryActiveBlog(category);
      }
    });
  }

  fetchBlogs() {
    if(this.authservice.isAuthenticated) {
      this.blogsRequest = {
        merchantId: this.settingService.getMerchantId(),
        userId: this.authservice.memberId.toString()
      }
    } else {
      this.blogsRequest = {
        merchantId: this.settingService.getMerchantId(),
        userId: ""
      }
    }

    return this.newsBlogService.getBlogs(this.blogsRequest);
  }

  getCategoryDays(categoryId: string): ICategoryDaysAssign | undefined {
    return this.SelectedDayCategory.find(x => x.categoryId === categoryId);
  }

  private readonly dayMap: Record<number, number> = {
    0: DayIDEnum.Sunday,
    1: DayIDEnum.Monday,
    2: DayIDEnum.Tuesday,
    3: DayIDEnum.Wednesday,
    4: DayIDEnum.Thursday,
    5: DayIDEnum.Friday,
    6: DayIDEnum.Saturday
  };

  private getTodayDayFlag(dayskip?): number {
    return this.dayMap[new Date().getDay()];
  }

  /*
  private getDaysStartingToday(): IDaysAssign[] {

    const currentDay = this.dayMap[new Date().getDay()];

    const startIndex = this.daysByCategory.findIndex(
      d => d.value === currentDay
    );

    return [
      ...this.daysByCategory.slice(startIndex),
      ...this.daysByCategory.slice(0, startIndex)
    ].map(day => ({
      ...day,
      selected: day.value === currentDay, // today's day is selected
      viewValue: {
        translations: {
          ...day.viewValue.translations
        }
      }
    }));
  }
  */

  private getDaysStartingToday(category: any): IDaysAssign[] {

    const currentDay = this.dayMap[new Date().getDay()];

    const startIndex = this.daysByCategory.findIndex(
      d => d.value === currentDay
    );

    const orderedDays = [
      ...this.daysByCategory.slice(startIndex),
      ...this.daysByCategory.slice(0, startIndex)
    ];

    // Works for either news or blogs
    const items = category.news ?? category.blogs ?? [];

    const selectedDay =
      orderedDays.find(day =>
        items.some(item =>
          item.dailyShowcase?.some(showcase =>
            showcase.dayID?.includes(day.value)
          )
        )
      )?.value ?? currentDay;

    return orderedDays.map(day => ({
      ...day,
      selected: day.value === selectedDay,
      viewValue: {
        translations: {
          ...day.viewValue.translations
        }
      }
    }));
  }
  
  /*
  shouldShowNews(news: ISingleNews, categoryId: string): boolean {
    const categoryDays = this.SelectedDayCategory.find(
      x => x.categoryId === categoryId
    );

    const activeDay = categoryDays?.selectedDay ?? this.getTodayDayFlag();

    if (!news.dailyShowcase?.length) {
      return true;
    }

    return news.dailyShowcase.some(showcase =>
      showcase.dayID?.includes(activeDay)
    );
  }
  */

  shouldShowNews(news: ISingleNews, categoryId: string): boolean {
    const categoryDays = this.SelectedDayCategory.find(
      x => x.categoryId === categoryId
    );

    const activeDay =
      categoryDays?.days.find(d => d.selected)?.value ??
      this.getTodayDayFlag();

    if (!news.dailyShowcase?.length) {
      return true;
    }

    return news.dailyShowcase.some(showcase =>
      showcase.dayID?.includes(activeDay)
    );
  }

  /*
  shouldShowBlog(blog: ISingleBlog, categoryId: string): boolean {
    const categoryDays = this.SelectedDayCategory.find(
      x => x.categoryId === categoryId
    );

    var activeDay = categoryDays?.selectedDay ?? this.getTodayDayFlag();

    if (!blog.dailyShowcase?.length) {
      return true;
    }


    //console.log(blog.dailyShowcase.some(showcase => showcase.dayID?.includes(activeDay)));

    return blog.dailyShowcase.some(showcase =>
      showcase.dayID?.includes(activeDay)
    );
  }
  */

  shouldShowBlog(blog: ISingleBlog, categoryId: string): boolean {

    const categoryDays = this.SelectedDayCategory.find(
      x => x.categoryId === categoryId
    );

    const activeDay =
      categoryDays?.days.find(d => d.selected)?.value ??
      this.getTodayDayFlag();

    if (!blog.dailyShowcase?.length) {
      return true;
    }

    return blog.dailyShowcase.some(showcase =>
      showcase.dayID?.includes(activeDay)
    );
  }


  getnewsImage(news){

    if(news.images){
      if(news.images.imgURL) {
        const url = news.images.imgURL;
        return url;
      }     
    }
  }

  getblogsImage(blogs){
    if(blogs.images){
      if(blogs.images.imgURL) {
        const url = blogs.images.imgURL;
        return url;
      }     
    }
  }

  async showmorenews(news, categoryDays?) {
    // setup a modal opening to the "news" component
    var currentdayData = null;
    if(categoryDays) {
      for(var i = 0; i < categoryDays.days.length; i++) {
        if(categoryDays.days[i].selected) {
          currentdayData = categoryDays.days[i];
        }
      }
    }
    
    /*
    if(news.longDescription || news.disclaimer || news.modalityLink) {
      if(news.longDescription.translations["en"] || news.longDescription.translations["fr"] || news.disclaimer.translations["en"] || news.disclaimer.translations["fr"] || news.modalityLink.translations["en"] || news.modalityLink.translations["fr"]) {
    */
        const modal = await this.modalCtrl.create({
          component: NewsComponent,
          cssClass: 'news-model',
          componentProps: {
            news: news,
            dayData: currentdayData,
            merchantId: this.settingService.getMerchantId()
          }
        });
      
        modal.onWillDismiss()
          .then((result) => {
            if (result.data === 'deleted') {
              this.getAllNews();
            }
        });
      
        await modal.present();
    /*
      }
    }
    */

    
  }

  deletenews(news) {
    // delete the specified news passing through

    this.deleteNews(news).subscribe(async completedDeletion => {
      if(completedDeletion) {
        this.getAllNews();
      }
    });
  }

  deleteNews(news) {
    this.updateNewsRequest = {
      merchantId: this.settingService.getMerchantId(),
      userId: this.authservice.memberId.toString(),
      newsId: news.id,
      status: "deleted"
    }

    return this.newsBlogService.updateNews(this.updateNewsRequest);
  }

  async showmoreblog(blog, categoryDays?) {
    // setup a modal opening to the "blogs" component

    var currentdayData = null;
    if(categoryDays) {
      for(var i = 0; i < categoryDays.days.length; i++) {
        if(categoryDays.days[i].selected) {
          currentdayData = categoryDays.days[i];
        }
      }
    }
    /*
    if(blog.longDescription || blog.disclaimer || blog.modalityLink) {
      if(blog.longDescription.translations["en"] || blog.longDescription.translations["fr"] || blog.disclaimer.translations["en"] || blog.disclaimer.translations["fr"] || blog.modalityLink.translations["en"] || blog.modalityLink.translations["fr"]) {
    */
        const modal = await this.modalCtrl.create({
          component: BlogsComponent,
          cssClass: 'blogs-model',
          componentProps: {
            blog: blog,
            dayData: currentdayData,
            merchantId: this.settingService.getMerchantId()
          }
        });
      
        modal.onWillDismiss()
          .then((result) => {
            if (result.data === 'deleted') {
              this.getAllBlogs();
            }
        });
      
        await modal.present();
    /*
      }
    }
    */
    
  }

  SelectNewsDay(day: IDaysAssign, category?: INews) {
    if (!category) {
      return;
    }

    const categoryDays = this.SelectedDayCategory.find(
      x => x.categoryId === category.id
    );

    if (!categoryDays) return;

    categoryDays.days.forEach(d => {
      d.selected = d.value === day.value;
    });

    categoryDays.selectedDay = day.value;

    this.initializeCategoryActiveNews(category);
  }

  SelectBlogsDay(day: IDaysAssign, category?: IBlogs) {
    if (!category) {
      return;
    }

    const categoryDays = this.SelectedDayCategory.find(
      x => x.categoryId === category.id
    );

    if (!categoryDays) return;

    categoryDays.days.forEach(d => {
      d.selected = d.value === day.value;
    });

    categoryDays.selectedDay = day.value;

    this.initializeCategoryActiveBlog(category);
  }

  initializeCategoryActiveNews(category: INews): void {

    const firstVisibleNews = category.news.find(news =>
      !news.deactivate &&
      (
        !category.weeklyFormat ||
        this.shouldShowNews(news, category.id)
      )
    );

    //console.log(firstVisibleNews);
    if (firstVisibleNews) {
      this.activeNewsByCategory[category.id] = firstVisibleNews.id;
    }
  }

  initializeCategoryActiveBlog(category: IBlogs): void {

    //console.log(category);

    const firstVisibleBlog = category.blogs.find(blog =>
      (!blog.deactivate) &&
      (
        !category.weeklyFormat ||
        this.shouldShowBlog(blog, category.id)
      )
    );

    //console.log(firstVisibleBlog);
    if (firstVisibleBlog) {
      this.activeBlogByCategory[category.id] = firstVisibleBlog.id;
    }
  }

  checkNewsBlogForDay(category: IBlogs | INews, day: IDaysAssign): boolean {

    if ('blogs' in category) {
      return category.blogs.some(blog =>
        blog.dailyShowcase.some(showcaseDay =>
          showcaseDay.dayID.includes(day.value)
        )
      );
    }

    if ('news' in category) {
      return category.news.some(news =>
        news.dailyShowcase.some(showcaseDay =>
          showcaseDay.dayID.includes(day.value)
        )
      );
    }

    return false;
  }


  getVisibleNews(category: INews): ISingleNews[] {
    return category.news.filter(news =>
      this.isNewsVisible(news, category)
    );
  }

  getVisibleBlogs(category: IBlogs): ISingleBlog[] {
    return category.blogs.filter(blog =>
      this.isBlogVisible(blog, category)
    );
  }
  
  private isNewsVisible(news: ISingleNews, category: INews): boolean {
    return (
      this.isWithinNewsDateRange(news) &&
      ((this.shouldShowNews(news, category.id) && !news.deactivate) ||
        !category.weeklyFormat)
    );
  }

  private isBlogVisible(blog: ISingleBlog, category: IBlogs): boolean {
    return (
      this.isWithinBlogDateRange(blog) &&
      ((this.shouldShowBlog(blog, category.id) && !blog.deactivate) ||
        !category.weeklyFormat)
    );
  }
  
  private isWithinNewsDateRange(news: ISingleNews): boolean {
    const now = new Date();

    const start = news.activationDate ? new Date(news.activationDate) : null;
    const end = news.expirationDate ? new Date(news.expirationDate) : null;

    if (start && now < start) return false;
    if (end && !news.noExpiration && now > end) return false;

    return true;
  }

  private isWithinBlogDateRange(blog: ISingleBlog): boolean {
    const now = new Date();

    const start = blog.activationDate ? new Date(blog.activationDate) : null;
    const end = blog.expirationDate ? new Date(blog.expirationDate) : null;

    if (start && now < start) return false;
    if (end && !blog.noExpiration && now > end) return false;

    return true;
  }

  
  getSrcImage(news?, blog?) {

    if(news) {
      //smaImage
      if (news.images.imgMobileShortName == null && news.images.imgMobileDisplayName) {
        const urlPath = news.images.imgMobileDisplayName;
        return "https://seemyapps.com" + urlPath;
      } else {
        //SMS image
        if(news.images){
          if(news.images.imgMobileURL) {
            const url = news.images.imgMobileURL;
            return url;
          }     
        }
      }
    } else if(blog) {
      if (blog.images.imgMobileShortName == null && blog.images.imgMobileDisplayName) {
        const urlPath = blog.images.imgMobileDisplayName;
        return "https://seemyapps.com" + urlPath;
      } else {
        //SMS image
        if(blog.images){
          if(blog.images.imgMobileURL) {
            const url = blog.images.imgMobileURL;
            return url;
          }     
        }
      }
    }
    
  }

  textDisplay(text, lang) {
    const fallbackLang = lang === 'en' ? 'fr' : 'en';

    return text.translations[lang] ?? text.translations[fallbackLang];
  }

  closePopup(){
    //if(this.isPopup) {
      this.modalCtrl.dismiss();
    //}
  }

}
